import { render, staticRenderFns } from "./JoyShareConfig.vue?vue&type=template&id=e2b56d56&scoped=true"
import script from "./JoyShareConfig.vue?vue&type=script&lang=js"
export * from "./JoyShareConfig.vue?vue&type=script&lang=js"
import style0 from "./JoyShareConfig.vue?vue&type=style&index=0&id=e2b56d56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b56d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b56d56')) {
      api.createRecord('e2b56d56', component.options)
    } else {
      api.reload('e2b56d56', component.options)
    }
    module.hot.accept("./JoyShareConfig.vue?vue&type=template&id=e2b56d56&scoped=true", function () {
      api.rerender('e2b56d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mealOrder/mealView/mealConfig/components/JoyShareConfig.vue"
export default component.exports